import './index.css';
import './fifa/fifa.css';
import { useEffect, useState } from 'react';
import { useAppStore } from './store';
import { SITE_MODE } from './config';
import BrandBackground from './brand/BrandBackground';
import NavBar from './brand/NavBar';
import Footer from './brand/Footer';
import Toast from './ui/Toast';
import OnboardingModal from './ui/OnboardingModal';
import LegalConsentGate from './ui/LegalConsentGate';
import PushLaunchModal from './ui/PushLaunchModal';
import ParticipantNotices from './ui/ParticipantNotices';
import SupportModal, { SupportFab } from './ui/SupportModal';
import HomePage from './pages/Home';
import AuthPage from './pages/Auth';
import RegisterPage from './pages/Register';
import ProfilePage from './pages/Profile';
import AdminPage from './pages/Admin';
import TeamPage from './pages/TeamPage';
import MatchesPage from './pages/Matches';
import TeamsPage from './pages/TeamsPage';
import NotificationsPage from './pages/Notifications';
import StreamPage from './pages/Stream';
// FIFA OPEN · СКО — витрина (src/fifa/), включается через SITE_MODE в config.js
import { FootballBackground } from './fifa/ui';
import FifaNavBar, { FifaBottomNav } from './fifa/NavBar';
import FifaHomePage from './fifa/Home';
import FifaBracketPage from './fifa/Bracket';
import FifaLivePage from './fifa/Live';
import FifaWinnersPage from './fifa/Winners';
// «Федерация киберспорта СКО» — новый дизайн (src/fed/), SITE_MODE = 'fed'
import FedApp from './fed/FedApp';

const isFifa = SITE_MODE === 'fifa';
const isFed = SITE_MODE === 'fed';

export default function App() {
  const { route, toast, user } = useAppStore();
  const userId = user?.id;
  const consentRequired = user?.legal_consent?.required !== false;
  const [supportOpen, setSupportOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 700);
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 700);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);

  // Заголовок вкладки и класс режима под активную витрину
  useEffect(() => {
    if (isFed) return; // заголовок и body-класс ставит FedApp
    document.title = isFifa
      ? 'FIFA OPEN · СКО — Турнир по EA SPORTS FC на PlayStation'
      : 'CS2 OPEN · СКО';
    document.body.classList.toggle('fifa-mode', isFifa);
  }, []);

  // Восстанавливаем сессию: после входа через Google — из токенов, которые
  // бэкенд вернул во фрагменте адреса, иначе — из localStorage
  useEffect(() => {
    const s = useAppStore.getState();
    if (s.hasOAuthRedirect()) s.completeOAuthLogin();
    else s.fetchMe();
  }, []);

  // После авторизации: грузим уведомления, запускаем поллинг и регистрируем Service Worker
  useEffect(() => {
    if (!userId || consentRequired) return;
    const s = useAppStore.getState();
    s.fetchNotifications();
    s.startNotificationPolling();
  }, [userId, consentRequired]);

  if (user && consentRequired) {
    return <><LegalConsentGate key={user.id} /><Toast toast={toast} /></>;
  }

  // ===== Новый дизайн «Федерация киберспорта СКО» =====
  if (isFed) {
    return (
      <>
        <FedApp />
        <OnboardingModal />
        <PushLaunchModal />
        <ParticipantNotices />
        <Toast toast={toast} />
      </>
    );
  }

  const page = {
    // Три публичные страницы: в режиме fifa — новые, в режиме cs — старые
    home: isFifa ? <FifaHomePage /> : <HomePage />,
    bracket: isFifa ? <FifaBracketPage /> : <HomePage />,
    stream: isFifa ? <FifaLivePage /> : <StreamPage />,
    winners: isFifa ? <FifaWinnersPage /> : <HomePage />,
    // Остальные страницы платформы работают в обоих режимах
    matches: <MatchesPage />,
    auth: <AuthPage />,
    signup: <AuthPage initialMode="signup" />,
    register: <RegisterPage />,
    profile: <ProfilePage />,
    admin: <AdminPage />,
    team: <TeamPage />,
    teams: <TeamsPage />,
    notifications: <NotificationsPage />,
  }[route] || (isFifa ? <FifaHomePage /> : <HomePage />);

  const isAdmin = route === 'admin';
  const hideNav = isAdmin && isMobile;
  // На страницах FIFA-витрины — футбольный фон, на служебных — прежний
  const fifaRoute = isFifa && ['home', 'bracket', 'stream', 'winners'].includes(route);

  return (
    <>
      {fifaRoute ? <FootballBackground intensity={1} /> : <BrandBackground intensity={1} />}
      <div className={isFifa ? 'fc-main-pad' : ''} style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', position: 'relative', zIndex: 1 }}>
        {!hideNav && (isFifa ? <FifaNavBar /> : <NavBar />)}
        <div style={{ flex: 1 }}>{page}</div>
        {!isAdmin && <Footer />}
      </div>
      {isFifa && !hideNav && <FifaBottomNav />}
      <OnboardingModal />
      <PushLaunchModal />
      <ParticipantNotices />
      <Toast toast={toast} />
      {!isAdmin && <SupportFab onClick={() => setSupportOpen(true)} />}
      <SupportModal open={supportOpen} onClose={() => setSupportOpen(false)} />
    </>
  );
}
